<template>
    <div class="step-5">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="checkout-card">
                    <div class="checkout-card-title">{{ $t('overview') }}</div>
                    <div class="checkout-card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{ $t('description') }}</th>
                                    <th class="text-right">{{ $t('price') }}</th>
                                    <th>&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <div>{{ $t('order') }}</div>
                                        <small>{{ $tc('n_products', items.quantity, {amount: items.quantity}) }}</small>
                                    </td>
                                    <td class="text-right">
                                        {{ items.total | currency }}
                                    </td>
                                    <td class="text-right">
                                        <a href="#" class="btn btn-light btn-sm"
                                           @click.prevent="editCart()">
                                            <span class="material-icon icon-create"/>
                                        </a>
                                    </td>
                                </tr>
                                <tr v-if="shippingOption">
                                    <td>
                                        <div>{{ shippingOption.title }}</div>
                                        <small v-html="shippingAddress"></small>
                                    </td>
                                    <td class="text-right">
                                        {{ shippingCost | currency }}
                                    </td>
                                    <td class="text-right">
                                        <a href="#" class="btn btn-light btn-sm"
                                           @click.prevent="gotToShippingOptions()">
                                            <span class="material-icon icon-create"/>
                                        </a>
                                    </td>
                                </tr>
                                <tr v-if="shippingSurcharges">
                                    <td>
                                      {{ $t('shipping_surcharges') }}
                                    </td>
                                    <td class="text-right">
                                      {{ shippingSurcharges | currency }}
                                    </td>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr v-if="paymentOption">
                                    <td>
                                        <div>{{ $t('payment_with') }}</div>
                                        <small>{{ paymentOption.payment_option.name }}</small>
                                    </td>
                                    <td class="text-right">
                                        <img v-if="paymentOption.payment_option && !isMobile"
                                             :src="paymentOption.payment_option.logo_asset"
                                             alt="" style="width: 90px; margin-top: 10px;">
                                    </td>
                                    <td class="text-right">
                                        <a href="#" class="btn btn-light btn-sm"
                                           @click.prevent="goToPaymentOptions()">
                                            <span class="material-icon icon-create"/>
                                        </a>
                                    </td>
                                </tr>
                                <tr v-if="couponsEnabled">
                                    <td>
                                        {{ $t('coupon') }}
                                    </td>
                                    <td class="text-right">
                                        {{ couponPrice | currency }}
                                    </td>
                                    <td class="text-right">
                                        <a href="#" v-if="!checkout.coupon" class="btn btn-light btn-sm"
                                           @click.prevent="gotToCoupon()">
                                            <span class="material-icon icon-add"/>
                                        </a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="checkout-card-total">{{ $t('total') }}</div>
                                    </td>
                                    <td class="text-right" :colspan="isMobile ? 2 : 1">
                                        <div class="checkout-card-total">{{ total | currency }}</div>
                                        <small>{{ $t('shopping_cart.include_vat', {amount: $options.filters.currency(vat)}) }}</small>
                                    </td>
                                    <td v-if="!isMobile" class="text-right">&nbsp;</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .checkout-card {
        padding: 80px 115px 50px;
        background-color: var(--bg-color);

        &-title {
            margin-bottom: 35px;
            color: var(--text-color);
            font-size: 1.5rem;
            text-align: center;
        }

        &-total {
            color: var(--text-color);
            font-size: 1.25rem;
            font-weight: 500;
        }

        table {

            > thead {

                > tr {

                    > th {
                        padding-top: 10px;
                        padding-bottom: 10px;
                        border: none;
                        color: var(--text-color);
                        font-size: 1.25rem;
                        font-weight: 500;

                        &:first-child {
                            padding-left: 0;
                        }

                        &:last-child {
                            padding-right: 0;
                        }
                    }
                }
            }

            > tbody {

                > tr {

                    > td {
                        padding-top: 37px;
                        padding-bottom: 37px;
                        border-top: 1px solid var(--bg-secondary-color-dark);
                        color: var(--text-color);
                        font-size: 1rem;
                        vertical-align: middle;

                        &:first-child {
                            padding-left: 0;
                        }

                        &:last-child {
                            padding-right: 0;
                            border-top: none;
                        }

                        &:nth-child(2) {
                            min-width: 130px;
                        }

                        > small {
                            display: block;
                            font-size: .87rem;
                            color: var(--text-secondary-color);
                        }
                    }
                }
            }
        }
    }

    body.-is-mobile {

        .checkout-card {
            padding: 30px 20px 0;

            .table-responsive {
                margin-bottom: 0;
            }

            table > tbody > tr {

                > td {

                    &:nth-child(2) {
                        min-width: 0;
                    }
                }

                &:last-child {

                    > td {
                        border-top: none;
                    }
                }
            }
        }
    }
</style>

<script>
  import checkoutStep6 from 'src/mixins/checkoutStep6Component';

  export default {
    mixins: [checkoutStep6],
  };
</script>